import React, {useCallback, useEffect} from 'react';
import styles from '../styles/pages/Settings.module.css';
import makeStyles from '@mui/styles/makeStyles';
import {BSTheme} from '../AppTheme';
import {useNavigate} from 'react-router-dom';
import NextButton from '../components/buttons/NextButton';

import {LegacyPerformance} from '../components/LegacyPerformance';
import {useStatsState} from '../model/state/tklStatsState';
import {ErrorPage} from '../components/ErrorInterrupter';

const useStyles = makeStyles((theme: BSTheme) => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingBottom: '40px',
    width: '444px',
  },
}));

const LegacyPerformancePage: React.FC = () => {
  const classes = useStyles();
  let navigate = useNavigate();

  const navigateToMainMenu = useCallback(() => {
    navigate('/welcomeBack');
  }, [navigate]);

  const navigateToTeamPerformance = useCallback(() => {
    navigate('/team-performance');
  }, [navigate]);
  const {data, inProgress, error} = useStatsState();

  useEffect(() => {
    document.title = 'Performance – Blank Slate';
  }, []);

  return (
    <div className={classes.container}>
      {typeof error !== 'undefined' ? (
        <ErrorPage error={error} onReset={() => {}} />
      ) : (
        <>
          <LegacyPerformance stat={data} inProgress={inProgress} />
          <div className={classes.buttonContainer}>
            {/* {Object.keys(stat?.topTeams || []).length !== 0 && (
          <NextButton
            text={'Team Performance'}
            onClick={navigateToTeamPerformance}
          />
        )} */}
            <NextButton text={'Close'} onClick={navigateToMainMenu} />
          </div>
        </>
      )}
    </div>
  );
};

export default LegacyPerformancePage;
